export const BEETINQ_TEAM_PAGE_SIZE = 10;
